document.addEventListener("DOMContentLoaded", function () {
  const editPositionElement = document.querySelector("#one-more");
  const cartItemsParent = document.querySelector(".cart__contents").parentNode;

  if (editPositionElement && cartItemsParent) {
    cartItemsParent.appendChild(editPositionElement);
  }
});

$(document).ready(function () {
  $(".one-more__submit").on("click", function () {
    const dataReference = $(this).closest("li").attr("data-reference");
    document.addEventListener("quantityUpdatedForRelatedProducts", (event) => {
      checkIfSkuIsInCart(dataReference, event.detail);
    });
    document.addEventListener("quantityUpdated", (event) => {
      checkIfSkuIsInCart(dataReference, event.detail);
    });
    // Check if there's an <li> element with matching sku-product attribute
  });
});

$(document).ready(function () {
  $(".add-to-cart-recommended")
    .off("submit")
    .on("submit", function (event) {
      event.preventDefault();

      var $form = $(this);
      var formData = $form.serializeArray();

      // Add isReturnable property to the form data
      formData.push({
        name: "properties[_is_returnable]",
        value: "true", // Set this value dynamically if needed
      });

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: $.param(formData),
        dataType: "json",
        success: function (data) {
          var formElem = $form[0];
          var product =
            window.kitDataLayer && window.kitDataLayer.addOneMore
              ? window.kitDataLayer.addOneMore(formElem)
              : null;

          if (
            product &&
            window.kitDataLayer &&
            typeof window.kitDataLayer.dispatchEvent === "function"
          ) {
            window.kitDataLayer.dispatchEvent({
              category: "ecommerce",
              action: "cart_add",
              placement: "cart_add_cart_page",
              context: {
                product: [product],
                event: "cart_add",
                list_name: "one-more",
                list_position: 1,
              },
            });
          } else {
            // Fallback log or direct fcbDL push
            console.warn("[kit-analytics] One more: analytics not available");
          }
          $.getJSON("/cart.js", function (cart) {
            const cartItemsElement = document.querySelector("cart-items");
            if (cartItemsElement) {
              // Update the cart UI
              const line = data.id;
              const allProductKeys = getRelatedProductsKeys(
                cartItemsElement,
                data.product_id
              );
              const quantity = data.quantity;
              const name = "updates[]";
              cartItemsElement.updateQuantityAndRelated(
                line,
                allProductKeys,
                quantity,
                name
              );
              console.log("updated one more");
            }
          });
        },
        error: function (xhr, status, error) {
          console.error(error);
        },
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const cartItems = document.querySelector("cart-items");

  if (cartItems && cartItems.classList.contains("is-empty")) {
    const editPositionElement = document.querySelector("#one-more");

    if (editPositionElement) {
      editPositionElement.style.display = "none";
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const dataReferenceElement = document.querySelector("li[data-reference]");
  if (!dataReferenceElement) {
    return;
  }
  const dataReferenceSku = dataReferenceElement.getAttribute("data-reference");
  const cartItems = document.querySelectorAll("li.fcb-cart-item");
  let itemExists = false;
  cartItems.forEach((item) => {
    const itemSku = item.getAttribute("sku-product");
    if (itemSku === dataReferenceSku) {
      itemExists = true;
    }
  });

  // If item with the same SKU exists, hide the dataReferenceElement
  if (itemExists) {
    dataReferenceElement.style.display = "none";
  }
});

function toggleSlider(dataReference, detail) {
  // Check if there's an <li.fcb-cart-item> element with matching data-reference attribute
  if (detail) {
    return checkIfSkuIsInCart(dataReference, detail);
  }
  const matchingCartItem = $(
    `li.fcb-cart-item[data-reference='${dataReference}']`
  );

  const displayCompletaProduct = () => {
    console.log("Quantity updated event received and trigger toggle");
    if (matchingCartItem.length > 0) {
      for (let i = 0; i < matchingCartItem.length; i++) {
        const matchCartItem = matchingCartItem[i];
        const computedStyle = window.getComputedStyle(matchCartItem);
        if (computedStyle.getPropertyValue("display") === "none") {
          matchCartItem.style.display = "block";
        }
      }
    }
  };

  // Add event listeners for quantity update events
  document.addEventListener("quantityUpdated", displayCompletaProduct);
  document.addEventListener(
    "quantityUpdatedForRelatedProducts",
    displayCompletaProduct
  );
}
document.addEventListener(
  "quantityUpdatedForRelatedProducts",
  function (event) {
    return checkIfSkuIsInCart(event.detail.sku, event.detail);
  }
);

// Function to check if an <li> element with the SKU is in the cart
function checkIfSkuIsInCart(dataReference, detail) {
  const isInCart = detail.data.items.some((item) => item.sku == dataReference);

  if (isInCart) {
    $(`li[data-reference='${dataReference}']`).css("display", "none");
  } else {
    $(`li[data-reference='${dataReference}']`).css("display", "block");
  }
}
